import React, { useState } from "react";
import toggleFullscreen from "toggle-fullscreen";
import styles from "./fullscreen-button.module.scss";
import PropTypes from "prop-types";

export default function FullscreenButton({ rootEl }) {
    const [isFullscreen, setIsFullscreen] = useState(false);

    return (
        <button
            className={styles.fullscreenButton}
            onClick={e => {
                const element = rootEl;
                setIsFullscreen(x => !x);
                toggleFullscreen(element).catch(console.log);
            }}
        >
            <img
                className={styles.fullscreenIcon}
                src={
                    process.env.PUBLIC_URL +
                    (isFullscreen
                        ? "/img/compress-solid.svg"
                        : "/img/expand-solid.svg")
                }
                alt="toggle fullscren"
            />
        </button>
    );
}

FullscreenButton.propTypes = {
    rootEl: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/fullscreen-button/fullscreen-button.js